<mat-card
    class="altair-card home-card mb-25 pb-0 bg-gray border-radius border-none d-block"
>
    <mat-card-content>
        <div class="row">
            <div class="col-xl-3 col-lg-3 col-6">
                <!-- Subdomains -->
                <app-subdomains #subdomains></app-subdomains>
            </div>
            <div class="col-xl-3 col-lg-3 col-6">
                <!-- Endpoints -->
                <app-endpoints #endpoints></app-endpoints>
            </div>
            <div class="col-xl-3 col-lg-3 col-6">
                <!-- Vulnerabilities -->
                <app-vulnerabilities #vulnerabilities></app-vulnerabilities>
            </div>
            <div class="col-xl-3 col-lg-3 col-6">
                <!-- OSINT -->
                <app-osint #osint></app-osint>
            </div>
            <div class="col-xl-7 col-lg-7 col-12">
                <!-- Target Information -->
                <app-target-information #targetInformation></app-target-information>
            </div>
            <div class="col-xl-5 col-lg-5 col-12">
                <!-- HTTP Status Breakdown -->
                <app-http-status #httpStatusBreakdown></app-http-status>
            </div>
            <div class="col-xl-12 col-lg-12 col-12">
                <!-- Geographical Distribution of Assets -->
            </div>
            @if (scan && scan.vulnerability_count && scan.vulnerability_count > 0) {
            <div class="col-xl-5 col-lg-5 col-12">
                <!-- Vulnerability Breakdown by Severity -->
                <app-vulnerability-breakdown #vulnerabilityBreakdown></app-vulnerability-breakdown>
            </div>
            <div class="col-xl-7 col-lg-7 col-12">
                <!-- Vulnerability Highlights -->
                 <app-vulnerability-highlights #vulnerabilityHighlights></app-vulnerability-highlights>
            </div>
            <div class="col-xl-6 col-lg-6 col-12">
                <!-- Most Vulnerable Subdomain -->
            </div>
            <div class="col-xl-6 col-lg-6 col-12">
                <!-- Most Common Vulnerabilities -->
            </div>
            }
            <div class="col-xl-6 col-lg-6 col-12">
                <!-- Important Subdomains -->
            </div>
            <div class="col-xl-6 col-lg-6 col-12">
                <!-- Recon Note/Todo -->
            </div>
            <div class="col-xl-4 col-lg-4 col-12">
                <!-- IP Addresses -->
                    <app-ip-addresses #ipAddresses></app-ip-addresses>
            </div>
            <div class="col-xl-4 col-lg-4 col-12">
                <!-- Discovered Ports -->
                <app-ports #ports></app-ports>
            </div>
            <div class="col-xl-4 col-lg-4 col-12">
                <!-- Discovered Technologies -->
                <app-technologies #technologies></app-technologies>
            </div>
        </div>
    </mat-card-content>
</mat-card>
